import { styled } from "@mui/material/styles";

const drawerWidth = 240;

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' && prop !== 'isMdScreen' })(
    ({ theme, open, isMdScreen }) => ({
        flexGrow: 1,
        padding: theme.spacing(2),
        paddingTop: theme.spacing(9),
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        marginLeft: isMdScreen ? 0 : `-${drawerWidth}px`,
        ...(open && !isMdScreen && {
            transition: theme.transitions.create('margin', {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.enteringScreen,
            }),
            marginLeft: 0,
        }),
    }),
);

export { Main, drawerWidth };